export default {
  name: 'job_preview_content',
  props: {
    parsed_document: Object,
    parsed_active_section: String,
    raw_text: String,
  },
  computed: {
    filtered_meta_fields() {
      if (!this.parsed_document?.meta) return [];
      return Object.entries(this.parsed_document.meta).filter(([, value]) => value);
    },
    has_parsed_content() {
      if (!this.parsed_document) return false;
      const doc = this.parsed_document;
      const metaFilled = Object.values(doc.meta || {}).some((v) => v);
      const hasPurpose = !!doc.job_purpose;
      const hasFunctions = Array.isArray(doc.main_functions) && doc.main_functions.length > 0;
      return metaFilled || hasPurpose || hasFunctions;
    },
  },
  methods: {
    format_label(key) {
      const labels = {
        post_title: 'Post Title',
        core_code: 'CORE Code',
        occupational_classification: 'Occupational Category',
        post_salary_level: 'Post/Salary Level',
        location: 'Location',
        branch_component: 'Branch/Component',
        reports_to: 'Reports To',
        incumbent_name: 'Incumbent Name',
      };
      return labels[key] || key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    },
  },
};
